import { render, staticRenderFns } from "./account_title.vue?vue&type=template&id=630bc24c&scoped=true"
import script from "./account_title.vue?vue&type=script&lang=js"
export * from "./account_title.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630bc24c",
  null
  
)

export default component.exports